import styled, { css } from 'styled-components';
import { ModalBackdropStyled } from '@bechtel/gds';
import { Box, IconStyled, TextFieldStyled, inputMediumStyles } from '@bechtel/gds';
import { SearchField } from '@bechtel/client-common';

export const DrawerBackdropStyled = styled(ModalBackdropStyled)`
  position: absolute;
  right: 0;
`;

export const DrawerOuterStyled = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  display: flex;
  flex-direction: column;
  height: 100%;
  right: 0;
  overflow: hidden;
  position: absolute;
  top: 0;
  width: 288px;
`;

interface ListSelectionStyledProps {
  isSubItem?: boolean;
}

export const ListSelectionStyled = styled.div<ListSelectionStyledProps>`
  ${({ theme, isSubItem }) => css`
    align-items: center;
    border-bottom: 1px solid ${theme.colors.grey[300]};
    cursor: pointer;
    display: flex;
    flex-direction: row;
    padding: ${theme.spacings[500]};
    &:hover {
      background-color: ${theme.colors.grey[100]};
    }
    ${isSubItem &&
    css`
      background-color: ${theme.colors.grey[100]};
      justify-content: space-between;
    `}
  `}
`;

export const SearchFieldStyled = styled(Box).attrs({
  mb: { sm: '400' },
  alignItems: { sm: 'center' },
  justifyContent: { sm: 'center' },
  p: { sm: '400' },
})`
  ${IconStyled} {
    right: ${({ theme }) => theme.spacings[500]};
  }
  ${TextFieldStyled} {
    ${({ theme }) => css`
      font-size: ${theme.fontSizes[400]};
      border-color: ${theme.colors.grey[300]};
      font-family: 'Graphik';
    `}
  }
`;

export const SearchFieldComponentStyled = styled(SearchField)`
  @media only screen and (max-width: ${({ theme }) => theme.breakpoints.widescreen}) {
    ${inputMediumStyles}
  }
`;
